// Brazilian Portuguese
export const pt_BR = {
    weeklyRewards: 'Recompensas semanais em',
    days: 'dias',
    hours: 'horas',
    minutes: 'min',
    seconds: 'seg',
    authenticating: 'Autenticando',
    verifyWallet: 'Por favor, aguarde enquanto verificamos sua carteira',
    authRequired: 'Autenticação necessária',
    authFailed: 'Falha na autenticação. Por favor, tente novamente.',
    points: 'Pontos',
    rank: 'Posição',
    of: 'de',
    players: 'jogadores',
    weeklyTopPlayers: 'Melhores jogadores da semana',
    thisWeekLeaderboard: 'Classificação desta semana',
    rankingsReset: 'A classificação é reiniciada todo domingo à meia-noite UTC',
    yourPoints: 'Seus pontos',
    dailyRewardAvailable: 'Recompensa diária disponível!',
    nextClaimAvailable: 'Próxima reivindicação disponível em:',
    claimDailyReward: 'Reivindicar recompensa diária',
    claiming: 'Reivindicando...',
    multiplier: 'Multiplicador',
    bonusPointsMultiplier: 'Multiplicador de pontos bônus',
    outOf: 'de',
    loading: 'Carregando...',
    errorLoading: 'Erro ao carregar',
    noEntries: 'Sem entradas',
    leaderboard: 'Classificação',
    tasks: 'Tarefas',
    rules: 'Regras',
    profile: 'Perfil',
    comingSoon: 'Em breve...',
    completedTasks: 'Tarefas concluídas',
    dailyRewardsClaimed: 'Recompensas diárias reivindicadas',
    times: 'vezes',
    recentActivity: 'Atividade recente',
    noRewardsClaimed: 'Nenhuma recompensa reivindicada ainda',
    dailyReward: 'Recompensa diária',
    howItWorks: 'Como funciona',
    welcomeMessage:
        'Bem-vindo ao Coinomi Rewards! Ganhe pontos completando várias tarefas e suba na classificação.',
    dailyRewardsTitle: 'Recompensas diárias',
    dailyRewardsRules: [
        'Reivindique sua recompensa diária a cada 24 horas',
        'Cada reivindicação vale 100 pontos',
        'Os pontos são multiplicados pelo seu multiplicador',
    ],
    multiplierBonusesTitle: 'Bônus multiplicadores',
    multiplierBonusesRules: [
        'Comece com multiplicador 1x',
        'Conecte o Telegram para bônus +10%',
        'Verifique o email para bônus +10%',
        'Bônus se acumulam para recompensas máximas',
    ],
    leaderboardTitle: 'Classificação',
    leaderboardRules: [
        'Compita com outros jogadores',
        'Classificação atualizada em tempo real',
        'Melhores jogadores recebem recompensas especiais',
    ],
    boostEarningsTitle: 'Aumente seus ganhos',
    boostEarningsRules: [
        'Complete desafios para bônus',
        'Junte-se à nossa comunidade do Telegram',
        'Mantenha-se ativo para recompensas máximas',
    ],
    challenges: 'Desafios',
    telegramChallenge: 'Desafio Telegram',
    emailChallenge: 'Desafio Email',
    connectTelegram: 'Conectar com Telegram',
    shareEmail: 'Compartilhar email',
    telegramSuccess:
        '🎉 Parabéns! Você agora recebe um bônus permanente de 10% em todas as recompensas!',
    telegramPrompt:
        'Conecte sua conta do Telegram para receber um bônus permanente de 10% em todas as recompensas!',
    emailSuccess:
        '🎉 Parabéns! Você agora recebe um bônus permanente de 10% em todas as recompensas!',
    emailPrompt:
        'Compartilhe seu email para receber um bônus permanente de 10% em todas as recompensas!',
    connectEmail: 'Conectar email',
    cancel: 'Cancelar',
    emailPrivacy:
        'Usamos seu email apenas para atualizações importantes e notificações de recompensas.',
    connectYourEmail: 'Conecte seu email',
    emailBonus:
        '🎉 Receba um bônus permanente de 10% em todas as recompensas conectando seu email!',
    enterValidEmail: 'Por favor, insira um endereço de email válido',
    emailAddress: 'Endereço de email',
    errorSavingEmail: 'Erro ao salvar email. Por favor, tente novamente.',
    claimButton: 'Reivindicar',
    earnedReward: 'Recompensa ganha',
    rewardValue: '{{amount}} Pontos',
    claimingReward: 'Reivindicando...',
    claimSuccess: 'Reivindicado com sucesso {{amount}} pontos!',
    claimError: 'Falha ao reivindicar. Por favor, tente novamente.',
    privacyDisclaimer:
        'Coinomi não coleta dados pessoais; um sistema de terceiros gerencia com segurança pontos e conexões sociais.',
    streakBonus: 'Bônus de sequência',
    streakDays: '{{days}}/5 Dias',
    streakBonusValue: '+{{percent}}%',
    streakMaxBonus: '+10% Extra',
    streakDescription: 'Reivindique 5 dias seguidos para bônus máximo',
    streakToday: 'Hoje',
    streakMissed: 'Perdido',
    streakComplete: 'Completo',
    streakActive: 'Sequência ativa',
    streakLost: 'Sequência perdida',
    streakNext: 'Próximo',
    home: 'Início',
    currentStreak: 'Sequência atual',
    totalClaims: 'Total de reivindicações',
    userStats: 'Suas estatísticas',
    referrals: 'Indicações',
    referralProgram: 'Programa de indicação',
    howReferralWorks: 'Como funcionam as indicações:',
    referralSteps: [
        'Compartilhe seu link de indicação com amigos',
        'Quando eles se juntam pelo seu link, tornam-se seus indicados',
        'Ganhe pontos bônus por cada indicação ativa',
        'Acompanhe suas indicações e ganhos aqui',
    ],
    referralRewards: 'Pontos de indicação concedidos:',
    referralBonuses: [
        '100 pontos por indicação',
        '10% de todos os pontos ganhos por seus indicados',
    ],
    yourReferralLink: 'Seu link de indicação',
    copyToClipboard: 'Copiar para área de transferência',
    linkCopied: 'Link copiado para área de transferência!',
    totalReferrals: 'Total de indicações',
    yourReferralCode: 'Seu código de indicação',
    referralCodeCopied: 'Código de indicação copiado!',
    editReferralCode: 'Editar código de indicação',
    editReferralCodeInstructions:
        'Escolha um novo código de indicação. Deve ter no mínimo 5 caracteres e pode incluir letras e números.',
    newReferralCode: 'Novo código de indicação',
    referralCodeRequirements: 'Mínimo 5 caracteres, apenas letras e números',
    updating: 'Atualizando...',
    update: 'Atualizar',
    referralCodeTaken: 'Este código de indicação já está em uso',
    haveReferralCode: 'Tem um código de indicação?',
    enterReferralCodePrompt:
        'Se alguém te indicou, insira o código deles aqui para conectar as contas.',
    enterReferralCode: 'Inserir código de indicação',
    enterReferralCodeInstructions: 'Insira o código de indicação que foi compartilhado com você.',
    referralCode: 'Código de indicação',
    referralCodeFormat: 'Apenas letras e números',
    submitting: 'Enviando...',
    submit: 'Enviar',
    enterCode: 'Inserir código',
    pleaseAddtoken: 'Por favor, adicione o parâmetro token à URL',
    authenticationError: 'Ocorreu um erro durante a autenticação',
    noUserFound: 'Nenhum usuário encontrado',
    userNotFoundMessage: 'Não foi possível encontrar dados do usuário',
    backToHome: 'Voltar ao início',
    retry: 'Tentar novamente',
    baseMultiplier: 'Multiplicador base',
    telegramBonus: 'Bônus Telegram',
    referralChallenge: 'Desafio de indicação',
    referralChallengePrompt:
        'Convide amigos e ganhe pontos bônus! Receba 100 pontos por cada indicação mais 10% dos ganhos deles.',
    startReferring: 'Começar a indicar',
    referralSuccess: '🎉 Parabéns! Você indicou usuários com sucesso e está ganhando pontos bônus!',
    unranked: 'Sem classificação',
    noPlayersYet: 'Seja o primeiro a se juntar!',
    shareVia: 'Compartilhar via',
    shareOn: 'Compartilhar no {{network}}',
    shareInviteText:
        '🚀 Estou ganhando crypto grátis com @CoinomiWallet!\n\nBaixe o Coinomi em coinomi.com/downloads e digite meu código de indicação {{referralCode}} para ganhar um bônus quando você entrar no #Coinomi Rewards no app.',
    pleaseAddUserId: 'Por favor, adicione o parâmetro userId à URL',
    emailChallengePrompt:
        'Compartilhe seu email para receber um bônus permanente de 10% em todas as recompensas!',
    emailChallengeSuccess:
        '🎉 Conectado! Você agora recebe um bônus permanente de 10% em todas as recompensas!',
    followKoalaWalletChallenge: 'Siga @coinomiWallet no Twitter para nos apoiar!',
    twitterAuthSuccessTitle: 'Twitter conectado com sucesso!',
    twitterAuthSuccessMessage:
        'Sua conta do Twitter foi conectada com sucesso. Agora você pode continuar usando o app.',
    continueToApp: 'Continuar para o app',
    twitter_like: 'Curtiu um tweet',
    twitter_retweet: 'Retweetou um tweet',
    disconnect: 'Desconectar',
    followCoinomiWallet: 'Siga @coinomiWallet no Twitter para nos apoiar!',
    connectedBonus:
        '🎉 Conectado! Agora você recebe um bônus permanente de 10% em todas as recompensas!',
};
